import { selectNotifications } from './notificationsSlice'
import Notification from './Notification'
import { useReduxSelector } from 'store'
import Reservation from './Reservation'
import React from 'react'
import './style.scss'

const reservation = <Reservation />
const Notifications: React.FC = () => {
  const notifications = useReduxSelector(selectNotifications)
  return (
    <div className='notification__list'>
      {reservation}
      {notifications.map((notification) => <Notification
        key={notification.id}
        {...notification}
      />)}
    </div>
  )
}

export default Notifications